<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">GÉNÉRER UN MANDAT SEPA</div>
</div>

@if (sepa) {
    <div class="col-12 pl-3 pt-2">
        Vous pouvez télécharger votre mandat SEPA actuel ici : <a (click)="downloadSepa()" class="pointer-cursor"><span
            class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span>MANDAT SEPA</a>
    </div>
}

<div class="col-12 pt-3">
    Si aucun prélèvement n'a été émis sur votre compte par {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }}
    depuis 36 mois, votre banque peut vous demander un nouveau mandat SEPA.
    <br><br>
    <strong>Pour générer un nouveau mandat SEPA, cliquez sur le bouton “Valider” ci-dessous.</strong>
    <br><br>
    Une fois que vous aurez validé cette demande, vous pourrez récupérer le nouveau mandat dans la rubrique Mes infos >
    Moyens de paiement.
    <div class="w-100 mt-3 cta_container text-center">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="submit" class="cta_btn level_2 column" (click)="save()">Valider<span></span></button>
    </div>
</div>
